(function () {
  const sections = Array.from(document.querySelectorAll("[data-kvsche-measure]"));

  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.kvscheMeasureInitialized === "true") return;
    section.dataset.kvscheMeasureInitialized = "true";

    const revealItems = Array.from(section.querySelectorAll(".reveal"));

    if (!("IntersectionObserver" in window)) {
      revealItems.forEach((item) => item.classList.add("is-visible"));
      return;
    }

    const showPastItems = () => {
      revealItems.forEach((item) => {
        const rect = item.getBoundingClientRect();

        if (rect.top < window.innerHeight * 0.92 || rect.bottom < 0) {
          item.classList.add("is-visible");
        }
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    revealItems.forEach((item) => observer.observe(item));
    showPastItems();
    window.addEventListener("pageshow", showPastItems, { once: true });

    document.addEventListener("shopify:section:unload", (event) => {
      if (event.target === section || event.target.contains(section)) {
        observer.disconnect();
      }
    });
  });
})();
